export const RAW_DATA_URL = import.meta.env.VITE_EVENTS_URL ?? "https://docs.google.com/spreadsheets/d/1Vlw6Jco0zRM0ePskVFi04MMY82vlyMcPxo3qRP9bzhI/gviz/tq?tqx=out:json&gid=0";
export const FETCH_TIMEOUT_MS = 10000;
export const MAX_RECURRENCE = 30;